module.exports = __webpack_public_path__ + "img/craneFrontRight.2928a7f1.svg";